<template>
    <div class="c-modal-search__triangle"></div>
    <form id="search-modal" class="o-form" @submit.prevent="setParams(true)">
        <h2 class="o-subtitle u-mb-xs">Recherche avancée</h2>
        <div class="o-flex -flex-gap-sm -flex-space-between -flex-align-center-over-sm u-mb-md">
            <div class="o-flex -flex-gap-sm -flex-align-center-over-sm o-flex__item">
                <div class="c-modal-search__input o-flex__item">
                    <div class="o-form-group">
                        <label class="o-label sr-only" for="search">Recherchez par mot.s-clé.s</label>
                        <div class="o-input__icon">
                            <input v-model="search" @keyup="updateSearch" class="o-input" type="search" id="search" name="Recherchez par mot.s-clé.s" placeholder="Recherchez par mot.s-clé.s">
                            <button class="o-input__icon__button" type="submit">
                                <Image id="search" />
                            </button>
                        </div>
                    </div>
                </div>
                <ul class="c-filter__list o-flex__item">
                    <li v-for="tag in outputFilters()" :key="tag.value" class="c-filter__item">
                        <button class="c-filter__item__close" @click="deleteFilter(tag.type, tag.value)">
                            <Image id="close" />
                        </button>
                        <span class="c-filter__item__title" v-html="tag.name"></span>
                    </li>
                </ul>
            </div>
            <div>
                <button class="c-modal-search__reset" @click="resetFilters" type="button">
                    Réinitialiser
                </button>
            </div>
        </div>
        <div class="c-modal-search__row">
            <div id="test-1" class="c-modal-search__col c-modal-search__accordion">
                <button class="c-modal-search__accordion__title" data-module="ClassToggle" data-target="#test-1" data-class="is-open">
                    <h2 class="o-subtitle">Catégories</h2>
                    <Image id="arrow-down-sm" />
                </button>
                <div class="c-modal-search__accordion__content o-form-group">
                    <div class="c-modal-search__accordion__content__inner">
                        <div class="c-modal-search__accordion__content__inner__inner o-checkbox__group -col-2">
                            <div v-for="category in allCategories" :key="category.id" class="o-checkbox__wrap">
                                <input class="o-checkbox" type="checkbox" :name="'category_'+category.slug" :id="'category_'+category.slug" :value="category.slug" @change="addFilter('categories', category.slug)" :checked="selectedCategories.includes(category.slug)">
                                <label class="o-checkbox-label" :for="'category_'+category.slug" v-html="category.name"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="test-2" class="c-modal-search__col c-modal-search__accordion">
                <button class="c-modal-search__accordion__title" data-module="ClassToggle" data-target="#test-2" data-class="is-open">
                    <h2 class="o-subtitle">Types</h2>
                    <Image id="arrow-down-sm" />
                </button>
                <div class="c-modal-search__accordion__content">
                    <div class="c-modal-search__accordion__content__inner">
                        <div class="c-modal-search__accordion__content__inner__inner o-form-group o-checkbox__group -col-1">
                            <div class="o-checkbox__wrap" v-for="type in allTypes" :key="type.term_id">
                                <input class="o-checkbox" type="checkbox" :name="'type_'+type.slug" :id="'type_'+type.slug" :value="type.slug" @change="addFilter('types', type.slug)" :checked="selectedTypes.includes(type.slug)">
                                <label class="o-checkbox-label" :for="'type_'+type.slug" v-html="type.name"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="test-3" class="c-modal-search__col c-modal-search__accordion">
                <button class="c-modal-search__accordion__title" data-module="ClassToggle" data-target="#test-3" data-class="is-open">
                    <h2 class="o-subtitle">Lieux</h2>
                    <Image id="arrow-down-sm" />
                </button>
                <div class="c-modal-search__accordion__content o-form-group">
                    <div class="c-modal-search__accordion__content__inner">
                        <div class="c-modal-search__accordion__content__inner__inner o-checkbox__group -col-1">
                            <div class="o-checkbox__wrap" v-for="place in allSalles" :key="place.ID">
                                <input class="o-checkbox" type="checkbox" :name="'place_'+place.post_name" :id="'place_'+place.post_name" :value="place.post_name" @change="addFilter('salles', place.post_name)" :checked="selectedSalles.includes(place.post_name)">
                                <label class="o-checkbox-label" :for="'place_'+place.post_name" v-html="place.post_title"></label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="c-modal-search__col">
                <div id="test-4" class="c-modal-search__accordion">
                    <button class="c-modal-search__accordion__title" data-module="ClassToggle" data-target="#test-4" data-class="is-open">
                        <h2 class="o-subtitle">Périodes</h2>
                        <Image id="arrow-down-sm" />
                    </button>
                    <div class="c-modal-search__accordion__content o-form-group">
                        <div class="c-modal-search__accordion__content__inner">
                            <div class="c-modal-search__accordion__content__inner__inner -reverse-mobile">
                                <div class="c-modal-search__date__parent">
                                    <div class="c-modal-search__date">
                                        <div class="c-modal-search__date__wrap">
                                            <span class="o-date-label">Entre le</span>
                                            <div class="o-form-group o-date__group">
                                                <label class="o-label sr-only" for="starting-date">Date de début</label>
                                                <input class="o-date" type="date" id="starting-date" name="Date de début" placeholder="AAAA/MM/JJ" v-model="dates.start">
                                            </div>
                                        </div>
                                        <div class="c-modal-search__date__wrap">
                                            <span class="o-date-label">Et le</span>
                                            <div class="o-form-group o-date__group">
                                                <label class="o-label sr-only" for="starting-date">Date de début</label>
                                                <input class="o-date" type="date" id="starting-date" name="Date de début" placeholder="AAAA/MM/JJ" v-model="dates.end">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr>
                                <div class="o-form-group o-checkbox__group -col-1">
                                    <div class="o-checkbox__wrap">
                                        <input class="o-checkbox" type="checkbox" name="today" id="today" value="today" @change="toggleDates(today)" :checked="this.today.start === this.dates.start && this.today.end === this.dates.end">
                                        <label class="o-checkbox-label" for="today">
                                            Aujourd'hui
                                        </label>
                                    </div>
                                    <div class="o-checkbox__wrap">
                                        <input class="o-checkbox" type="checkbox" name="weekend" id="weekend" value="weekend" @change="toggleDates(thisweekend)" :checked="this.thisweekend.start === this.dates.start && this.thisweekend.end === this.dates.end">
                                        <label class="o-checkbox-label" for="weekend">
                                            Ce week-end
                                        </label>
                                    </div>
                                    <div class="o-checkbox__wrap">
                                        <input class="o-checkbox" type="checkbox" name="next7" id="next7" value="next7" @change="toggleDates(next7)" :checked="this.next7.start === this.dates.start && this.next7.end === this.dates.end">
                                        <label class="o-checkbox-label" for="next7">
                                            7 prochains jours
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="o-flex -flex-align-center-over-sm -flex-space-between -flex-wrap -flex-gap-xs u-mt-sm">
                    <div class="c-modal-search__count">
                        {{ totalResults }} résultats
                    </div>
                    <div>
                        <button class="o-button -button-show-results" type="submit" aria-label="Afficher les résultats">
                            <span class="o-button__text">Afficher les résultats</span>
                            <span class="sr-only">Afficher les résultats</span>
                            <Image id="eye" />
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>
<script>
import Fuse from 'fuse.js'
import Spinner from './parts/Spinner.vue'
import Image from './parts/Image.vue'
import { toRaw } from 'vue'

export default {
    props: {
        page: {
            type: String,
            required: true 
        }
    },
    data() {
        return {
            loading: true,
            allSpectacles: [],
            allCategories: [],
            allTypes: [],
            allSalles: [],
            selectedCategories: [],
            selectedTypes: [],
            selectedSalles: [],
            dates: {
                start: '',
                end: ''
            },
            pagination: {
                perPage: 12,
                currentPage: 1,
                pages:[],
            },
            filteredSpectacles: [],
            spectacles: [],
            search: '',
            totalResults: 0,
        }
    },
    components: {
        Spinner,
        Image
    },
    watch: {
        dates: {
            handler() {
                this.filterSpectacles();
                if (this.page == window.location.pathname || this.page == window.location.href) {
                    document.$trigger('updateFilters',{
                        from: "modal",
                        selectedCategories: this.selectedCategories,
                        selectedTypes: this.selectedTypes,
                        selectedSalles: this.selectedSalles,
                        dates: this.dates,
                        search: this.search
                    });
                }
            },
            deep: true
        }
    },
    computed: {
        isWeekendChecked() {
            return (this.thisweekend.start === this.dates.start && this.thisweekend.end === this.dates.end);
        },
        today() {
            //Return a start and end date for the current day
            let today = new Date();
            return {
                start: today.toISOString().split('T')[0],
                end: today.toISOString().split('T')[0]
            };
        },
        next7() {
            //Return a start and end date for the current next 7 days
            const today = new Date();
            const first = new Date().setDate(today.getDate() + 7);
            const next7 = new Date(first);
            return {
                start: today.toISOString().split('T')[0],
                end: next7.toISOString().split('T')[0]
            };
        },
        thisweekend() {
            //Return a start and end date for the current weekend
            let today = new Date();
            const day = today.getDay();
            const diff = today.getDate() - day + (day == 0 ? -6 : 5); // adjust when day is sunday
            const saturday = new Date(today.setDate(diff));
            const sunday = new Date(today.setDate(diff + 1));
            return {
                start: saturday.toISOString().split('T')[0],
                end: sunday.toISOString().split('T')[0]
            };
        }
    },
    methods: {
        toggleDates(date) {
            if(this.dates.start === date.start && this.dates.end === date.end) {
                this.dates.start = '';
                this.dates.end = '';
            } else {
                this.dates.start = date.start;
                this.dates.end = date.end;
            }
        },
        updateSearch(e) {
            if(e && e.key === 'Enter') {
                this.setParams(true);
                return;
            }
            this.filterSpectacles();
            if (this.page == window.location.pathname || this.page == window.location.href) {
                document.$trigger('updateFilters',{
                    from: "modal",
                    selectedCategories: this.selectedCategories,
                    selectedTypes: this.selectedTypes,
                    selectedSalles: this.selectedSalles,
                    dates: this.dates,
                    search: this.search
                });
            }
        },
        outputFilters() {
            let tags = [];
            if (this.selectedCategories.length > 0) {
                for (let category of this.selectedCategories) {
                    if (!this.allCategories || this.allCategories.length == 0) return;
                    const foundCategory = this.allCategories.find(c => c.slug === category);
                    if (foundCategory) {
                        tags.push({
                            type: 'categories',
                            value: category,
                            name: foundCategory.name
                        });
                    }
                }
            }
            if (this.selectedTypes.length > 0) {
                if(!this.allTypes || this.allTypes.length == 0) return;
                for (let type of this.selectedTypes) {
                    let foundType = this.allTypes.find(t => t.slug === type);
                    if(foundType) {
                        tags.push({
                            type: 'types',
                            value: type,
                            name: foundType.name
                        });
                    }
                }
            }
            if (this.selectedSalles.length > 0) {
                if(!this.allSalles || this.allSalles.length == 0) return;
                for (let salle of this.selectedSalles) {
                    let foundSalle = this.allSalles.find(s => s.post_name === salle);
                    if(foundSalle){
                        tags.push({
                            type: 'salles',
                            value: salle, 
                            name: foundSalle.post_title
                        });
                    }
                }
            }
            if(this.dates.start && this.dates.end) {
                tags.push({
                    type: 'dates',
                    value: this.dates.start + ' - ' + this.dates.end,
                    name: this.dates.start + ' - ' + this.dates.end
                });
            }
            return tags;
        },
        addFilter(type, value) {
            if (type === 'categories') {
                if (this.selectedCategories.includes(value)) {
                    this.selectedCategories = this.selectedCategories.filter(category => category !== value);
                } else {
                    this.selectedCategories.push(value);
                }
            }
            if (type === 'types') {
                if (this.selectedTypes.includes(value)) {
                    this.selectedTypes = this.selectedTypes.filter(type => type !== value);
                } else {
                    this.selectedTypes.push(value);
                }
            }
            if (type === 'salles') {
                if (this.selectedSalles.includes(value)) {
                    this.selectedSalles = this.selectedSalles.filter(salle => salle !== value);
                } else {
                    this.selectedSalles.push(value);
                }
            }
            this.filterSpectacles();
            this.resetInput();
            //trigger event updateFilters global event
            if (this.page == window.location.pathname || this.page == window.location.href) {
                document.$trigger('updateFilters',{
                    from: "modal",
                    selectedCategories: this.selectedCategories,
                    selectedTypes: this.selectedTypes,
                    selectedSalles: this.selectedSalles,
                    dates: this.dates,
                    search: this.search
                });
            }
        },
        deleteFilter(type, value) {
            if (type === 'categories') {
                this.selectedCategories = this.selectedCategories.filter(category => category !== value);
            }
            if (type === 'types') {
                this.selectedTypes = this.selectedTypes.filter(type => type !== value);
            }
            if (type === 'salles') {
                this.selectedSalles = this.selectedSalles.filter(salle => salle !== value);
            }
            if (type === 'dates') {
                this.dates.start = '';
                this.dates.end = '';
            }
            this.filterSpectacles();
            if (this.page == window.location.pathname || this.page == window.location.href) {
                document.$trigger('updateFilters',{
                    from: "modal",
                    selectedCategories: this.selectedCategories,
                    selectedTypes: this.selectedTypes,
                    selectedSalles: this.selectedSalles,
                    dates: this.dates,
                    search: this.search
                });
            }
        },
        resetFilters() {
            this.selectedCategories = [];
            this.selectedTypes = [];
            this.selectedSalles = [];
            this.dates.start = '';
            this.dates.end = '';
            this.search = '';
            this.filterSpectacles();
            if (this.page == window.location.pathname || this.page == window.location.href) {
                document.$trigger('updateFilters',{
                    from: "modal",
                    selectedCategories: this.selectedCategories,
                    selectedTypes: this.selectedTypes,
                    selectedSalles: this.selectedSalles,
                    dates: this.dates,
                    search: this.search
                });
            }
        },
        resetInput() {
            const inputs = document.querySelectorAll('select');
            inputs.forEach(input => {
                input.value = '';
            });
        },
        fetchListing() {
            this.getParams();
            // Fetch listing from API
            let random = Math.floor(Math.random() * 1000);
            fetch("/wp-json/stereo/v1/spectacles?"+random, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'X-WP-Nonce': WPURLS.nonce
                }
            })
            .then(response => response.json())
            .then(data => {
                this.allSpectacles = data.spectacles;
                this.allCategories = this.notEmpty(data.categories, 'show_cat', data.spectacles);
                this.allTypes = this.notEmpty(data.types, 'show_type', data.spectacles);
                this.allSalles = this.notEmpty(data.salles, 'show_salle', data.spectacles);
                this.filterSpectacles();
                //Reinit data-module inside
                let newContainer = document.getElementById('search-modal');
                this.modu.call('update', newContainer, 'app');
                this.loading = false;
            })
        },
        notEmpty(data, type, spectacles) {
            if (type === 'show_cat') {
                //base on this.allSpectacles data don't show categories that are not in the spectacles
                const categories = data.filter(category => {
                    return spectacles.some(spectacle => {
                        if(!Array.isArray(spectacle.categories) || spectacle.categories.length === 0) return;
                        return spectacle.categories.some(cat => cat.slug === category.slug);
                    });
                });
                return categories;
            }else if (type === 'show_type') {
                //base on this.allSpectacles data don't show types that are not in the spectacles
                const types = data.filter(type => {
                    return spectacles.some(spectacle => {
                        if(!Array.isArray(spectacle.types) || spectacle.types.length === 0) return;
                        return spectacle.types.some(t => t.slug === type.slug);
                    });
                });
                return types;
            }else if (type === 'show_salle') {
                //base on this.allSpectacles data don't show salles that are not in the spectacles
                const salles = data.filter(salle => {
                    return spectacles.some(spectacle => {
                        return spectacle.salle.post_name === salle.post_name;
                    });
                });
                return salles;
            }

            return data;
        },
        getParams() {
            const urlParams = new URLSearchParams(window.location.search);
            const categories = urlParams.get('categories');
            const types = urlParams.get('types');
            const salles = urlParams.get('salles');
            const start_date = urlParams.get('start_date');
            const end_date = urlParams.get('end_date');
            const search = urlParams.get('search');
            const page = urlParams.get('pa');

            if (categories) {
                this.selectedCategories = categories.split(',');
            }
            if (types) {
                this.selectedTypes = types.split(',');
            }
            if (salles) {
                this.selectedSalles = salles.split(',');
            }
            if (start_date) {
                this.dates.start = start_date;
            }
            if (end_date) {
                this.dates.end = end_date;
            }
            if (search) {
                this.search = search;
            }

            if (page) {
                this.pagination.currentPage = page;
            }
        },
        setParams(close=false) {
            const urlParams = new URLSearchParams(window.location.search);
            const categories = this.selectedCategories.join(',');
            const types = this.selectedTypes.join(',');
            const salles = this.selectedSalles.join(',');
            const start_date = this.dates.start;
            const end_date = this.dates.end;
            const search = this.search;
            const page = this.pagination.currentPage;

            urlParams.set('categories', categories);
            urlParams.set('types', types);
            urlParams.set('salles', salles);
            urlParams.set('start_date', start_date);
            urlParams.set('end_date', end_date);
            urlParams.set('search', search);
            urlParams.set('pa', page);
            //check if page is the same
            if (this.page == window.location.pathname || this.page == window.location.href) {
                window.history.replaceState(false, '', `${window.location.pathname}?${urlParams}`);
                if(close) {
                    this.closeAdvancedSearch();
                }
            } else {
                //Location href with new params
                window.location.href = this.page + '?' + urlParams.toString();
            }
        },
        async filterSpectacles(set = false) {
            this.filteredSpectacles = await Promise.all(this.allSpectacles.map(async spectacle => {
                let show = true;
                if (this.selectedCategories.length > 0) {
                    if(!Array.isArray(spectacle.categories) || spectacle.categories.length === 0) return;
                    if(show) show = this.selectedCategories.includes(spectacle.categories[0].slug);
                }
                if (this.selectedTypes.length > 0) {
                    if (!Array.isArray(spectacle.types) || spectacle.types.length === 0) return;
                    if(show) show = this.selectedTypes.includes(spectacle.types[0].slug);
                }
                if (this.selectedSalles.length > 0) {
                    //spectacle.salle.post_name
                    if(show) show = this.selectedSalles.includes(spectacle.salle.post_name);
                }
                if (this.dates.start && this.dates.end) {
                    if(show) show = await this.checkDates(spectacle);
                }
                return show ? spectacle : null;
            }));

            this.filteredSpectacles = this.filteredSpectacles.filter(show => show);

            if(this.search.length > 1){
                const fuse = new Fuse(this.filteredSpectacles, {
                    shouldSort: false,
                    threshold: 0.3,
                    keys: ['artiste', 'nom_spectacle', 'representations.fields.code_local', 'representations.fields.code_representation']
                });
                const result = fuse.search(this.search);
                this.filteredSpectacles = result;
            }

            if (set){
                this.setParams();
            }
        
            this.totalResults = this.filteredSpectacles.length;
            //this.setParams();
        },
        async checkDates(spectacle) {
            let show = false;
            await Promise.all(spectacle.representations.map(async (representation) => {
                //if representation.date_heure only have Y-m-d format add 00:00:00
                if(!representation.date_heure.includes('T')) {
                    representation.date_heure += 'T00:00:00';
                }

                const representationDate = new Date(
                    new Date(representation.date_heure).toLocaleString("en-US", { timeZone: "America/Toronto" })
                );
                const representationEndDate = new Date(
                    new Date(representation.end_date+ "T23:59:59").toLocaleString("en-US", { timeZone: "America/Toronto" })
                );

                const startDate = new Date(
                    new Date(this.dates.start + "T00:00:00").toLocaleString("en-US", { timeZone: "America/Toronto" })
                );
                const endDate = new Date(
                    new Date((this.dates.end ? this.dates.end : this.dates.start) + "T23:59:59").toLocaleString("en-US", { timeZone: "America/Toronto" })
                );

                if (representationDate >= startDate && representationDate <= endDate) {
                    show = true;
                }

                // Générer les jours de la semaine dans la plage
                const days = [];
                for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
                    days.push(d.getDay());
                }

                // Vérifier si representation.days contient un jour valide
                if (representation.days && representation.days.length > 0) {
                    // Ne rien faire si la représentation commence après la plage de dates filtrée
                    if (representationDate > endDate) {
                        show = false;
                        return;
                    }
                    // Ne rien faire si la représentation se termine avant la plage de dates filtrée
                    if (representation.end_date && representationEndDate < startDate) {
                        show = false;
                        return;
                    }
                    const repDays = Array.isArray(representation.days)
                        ? toRaw(representation.days).map(day => Number(day))
                        : [Number(representation.days)];
                    // Générer les jours de la semaine dans la plage
                    const hasValidDay = repDays.some(day => days.includes(day));
                    if (hasValidDay) {
                        show = true;
                    } else {
                        show = false;
                    }
                    // Optionally log for debugging
                }
            }));
            return show;
        },
        closeAdvancedSearch() {
            const modal = document.querySelector(".js-modal");
            modal.close();
        }
    },
    mounted() {
        if (this.page == window.location.pathname || this.page == window.location.href) {
            let thisModu = this;
            document.$on('dataLoaded', (data) => {
                thisModu.getParams();
                thisModu.allSpectacles = data.detail.data.spectacles;
                thisModu.allCategories = data.detail.data.categories;
                thisModu.allTypes = data.detail.data.types;
                thisModu.allSalles = data.detail.data.salles;
                thisModu.filterSpectacles();
                //Reinit data-module inside
                let newContainer = document.getElementById('search-modal');
                thisModu.modu.call('update', newContainer, 'app');
                thisModu.loading = false;
            });
        } else {
            this.fetchListing();
        }
        document.$on('updateFilters', (data) => {
            if(data.detail.from == 'modal') return;
            this.selectedCategories = data.detail.selectedCategories;
            this.selectedTypes = data.detail.selectedTypes;
            this.selectedSalles = data.detail.selectedSalles;
            this.dates = data.detail.dates;
            this.search = data.detail.search;

            this.filterSpectacles();
        });
    }
}
</script>